module.exports = __webpack_public_path__ + "img/20240111_thanks.f15a4a52.jpg";